import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { governmentPage } from '../../data/applicationPages';
export function GovernmentPage() {
  return <ApplicationPage content={governmentPage} data-id="element-1792" data-mp="17qpotp62uvsq" />;
}